import { render, staticRenderFns } from "./DashboardTopInfo.vue?vue&type=template&id=ef051b9a"
import script from "./DashboardTopInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardTopInfo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports